import { processElection } from "@/helpers/parse";
import { formatDate } from "../helpers/formatting";

const ADD_ELECTION = "ADD_ELECTION";

const initialState = {
  list: {},
  error: null,
};

const mutations = {
  [ADD_ELECTION](state, results) {
    if (typeof results.geoSelection === "undefined") {
      results.geoSelection = null;
    }
    if (typeof results.geoType === "undefined") {
      results.geoType = null;
    }
    if (typeof results.geographies === "undefined") {
      results.geographies = [];
    }
    state.list = results;
  },
};

function fetchRace(raceID) {
  return fetch(`https://embed-api.ddhq.io/v1/races/${raceID}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Unable to get race ${raceID}`);
      }

      try {
        return response.json();
      } catch {
        throw new Error(`Unable to parse JSON response data from race ${raceID}`);
      }
    })
    .catch((error) => {
      console.error(`Encountered error fetching race ${raceID}. ${error}`);
      return null;
    });
}

const actions = {
  async fetchRaces({ rootGetters }, s3Path) {
    try {
      let response = await rootGetters.api.get(s3Path);
      return response.data;
    } catch (err) {
      throw new err();
    }
  },
  async fetchResults({ dispatch }, { id, s3Path, params }) {
    try {
      let results;
      if (s3Path !== null) {
        const response = await Promise.all([dispatch("fetchRaces", s3Path)]);
        const elections = response[0].data || [response[0]];
        let data = [];
        for (let i = 0; i < elections.length; i++) {
          const election = elections[i];
          results = processElection(
            params,
            election,
            election.countyResults,
            election.toplineResults,
            election.vcuResults
          );
          results.lastUpdated = formatDate(new Date());
          results.candidates.sort((a, b) => b.votes - a.votes);
          data.push(results);
        }
        data = data.sort((a, b) =>
          a.full_title.localeCompare(b.full_title, undefined, { numeric: true })
        );
        return data;
      } else {
        const unprocessedElection = await fetchRace(id);
        if (unprocessedElection === null) return;

        const countyResults = unprocessedElection?.vcus ?? unprocessedElection?.counties ?? [];
        const toplineResults = unprocessedElection.topline_results;
        const election = processElection(
          params,
          unprocessedElection,
          countyResults,
          toplineResults
        );

        election.lastUpdated = formatDate(new Date());
        election.candidates.sort((a, b) => b.votes - a.votes);
        return election;
      }
    } catch (error) {
      dispatch("setError", error);
      throw error;
    }
  },
};

const getters = {
  elections(state) {
    return state.list;
  },
};

export default {
  namespaced: false,
  state: initialState,
  mutations,
  actions,
  getters,
};
